import { Component, OnDestroy } from '@angular/core';
import { Usuario as UsuarioAsignacion } from '@shared/models/usuarios/Usuarios';
import { ActivatedRoute } from '@angular/router';
import { ListadoAsignaciones } from '@shared/enums/ListadoAsignaciones';
import { UsuarioService } from '@account/usuario.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ItemMultiFiltro } from '@shared/multifiltro/ItemMultifiltro';
import { AeroplantasService } from '@management/asignacion-aeroplantas/services/aeroplantas.service';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { MessageService } from '@shell/message.service';
import { UsuarioAeroplanta } from '@shared/models/abm/UsuarioAeroplanta';
import { Usuario } from '@shared/models/despacho/Usuario';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-listado-asignaciones',
  templateUrl: './listado-asignaciones.component.html',
  styleUrl: './listado-asignaciones.component.scss'
})
export class ListadoAsignacionesComponent implements OnDestroy {

  title: string = "";
  usuarios: UsuarioAsignacion[] = [];
  usuariosFiltrados: UsuarioAsignacion[] = [];
  seleccionados: UsuarioAsignacion[] = [];
  usuariosFiltradosMultifiltro: UsuarioAsignacion[] = [];
  loading: boolean = false;
  busquedaFormControl = new FormControl('');
  usuarioFormControl = new FormControl(null);
  listadoAsignaciones: ListadoAsignaciones;
  ListadoAsignaciones = ListadoAsignaciones;
  listaUsuarios: Usuario[] = [];
  cargandoUsuarios: boolean = false;
  usuarioValido: boolean = false;

  // multifiltro
  usuariosMultiFiltro: ItemMultiFiltro[] = [];
  rolesMultiFiltro: ItemMultiFiltro[] = [];
  dniMultiFiltro: ItemMultiFiltro[] = [];
  aeroplantasMultiFiltro: ItemMultiFiltro[] = [];
  private destroy$ = new Subject<void>();
  TipoUsuario = TipoUsuario;

  constructor(
    public authService: AuthService,
    private usuarioService: UsuarioService,
    private messageService: MessageService,
    private aeroplantasService: AeroplantasService,
    private spinner: NgxSpinnerService,
    router: ActivatedRoute
  ) {
    router.queryParams.subscribe(params => {
      this.destroy$.next();

      const param = params['param'] as string;
      this.listadoAsignaciones = Number(param) as ListadoAsignaciones;
      this.initPage(this.listadoAsignaciones);
    });
  }

  initPage(listadoAsignaciones: ListadoAsignaciones) {
    this.usuarioFormControl.setValue(null);
    this.usuarios = [];
    this.usuariosFiltrados = [];
    this.usuariosFiltradosMultifiltro = [];
    switch (listadoAsignaciones) {
      case ListadoAsignaciones.Pendientes:
        this.title = "Pendientes";
        this.obtenerAsignacionesPendientes();
        break;
      case ListadoAsignaciones.Manual:
        this.obtenerUsuarios(listadoAsignaciones);
        this.title = "Manual";
        break;
      case ListadoAsignaciones.Asignados:
        this.obtenerUsuarios(listadoAsignaciones);
        this.title = "Asignados";
        break;
      default:
        this.title = "None";
        break;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  filtrarTabla() {
    this.usuariosFiltrados = this.usuarios.filter(u => {
      let agregar = true;
      if (this.busqueda.value) {
        agregar = u.nombresCompletos && u.nombresCompletos.toLocaleLowerCase().indexOf(this.busqueda.value.toLocaleLowerCase()) > -1;
        agregar = agregar || (u.dni && u.dni.toLocaleLowerCase().indexOf(this.busqueda.value.toLocaleLowerCase()) > -1);
        agregar = agregar || (u.rol && u.rol.toLocaleLowerCase().indexOf(this.busqueda.value.toLocaleLowerCase()) > -1);
        agregar = agregar || (u.codigoAeroplanta && u.codigoAeroplanta.toLocaleLowerCase().indexOf(this.busqueda.value.toLocaleLowerCase()) > -1);
      }

      return agregar;
    });

    this.filtrarPorMultifiltro();
  }

  filtrarPorMultifiltro() {
    if (this.usuariosFiltrados != null) {

      this.usuariosFiltradosMultifiltro = this.usuariosFiltrados.filter(u => {
        let view = true;

        if (this.usuariosMultiFiltro.some(elemento => elemento.seleccionado)) {
          view = view && (
            this.usuariosMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == u.nombresCompletos)
          );
        }
        
        if (this.rolesMultiFiltro.some(elemento => elemento.seleccionado)) {
          view = view && (
            this.rolesMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == u.rol)
          );
        }

        if (this.dniMultiFiltro.some(elemento => elemento.seleccionado)) {
          view = view && (
            this.dniMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == u.dni)
          );
        }

        if (this.aeroplantasMultiFiltro.some(elemento => elemento.seleccionado)) {
          view = view && (
            this.aeroplantasMultiFiltro.filter(elemento => elemento.seleccionado).some(elementoAux => elementoAux.id == u.codigoAeroplanta)
          );
        }

        return view;
      });
    }
  }

  handleSpinner(load: boolean) {
    load ? this.spinner.show('spinnerGrafico') :  this.spinner.hide('spinnerGrafico');
    this.loading = load;
  }

  toggleSeleccion(usuario: any) {
    const index = this.seleccionados.indexOf(usuario);
    if (index === -1) {
      this.seleccionados.push(usuario);
    } else {
      this.seleccionados.splice(index, 1);
    }
  }

  obtenerUsuarios(tipo: ListadoAsignaciones) {
    this.handleSpinner(true);
    this.cargandoUsuarios = true;
    if (tipo===ListadoAsignaciones.Manual) {
      this.usuarioService.obtenerTodosLosUsuarios()
        .pipe(takeUntil(this.destroy$))
        .subscribe(usuarios => {
          usuarios = usuarios.sort((a, b) => { if (a.nombresCompletos > b.nombresCompletos) { return 1 } else { return -1 } });
          this.listaUsuarios = usuarios;
          this.cargandoUsuarios = false;
          this.filtrarPorMultifiltro();
          this.handleSpinner(false);
        }, () => {
          this.cargandoUsuarios = false;
          this.handleSpinner(false)
        });
    } else {
      this.usuarioService.obtenerTodosLosUsuariosAsignados(true, true, this.idAprobador)
      .pipe(takeUntil(this.destroy$))
        .subscribe(usuarios => {
          usuarios = usuarios.sort((a, b) => { if (a.nombresCompletos > b.nombresCompletos) { return 1 } else { return -1 } });        
          this.usuarios = usuarios;
          this.usuariosFiltrados = usuarios;         
          this.cargandoUsuarios = false;
          this.filtrarPorMultifiltro();
          this.handleSpinner(false);
        }, () => {
          this.cargandoUsuarios = false;
          this.handleSpinner(false)
        });
    }
  }

  formatterUsuario = (u: { nombresCompletos: string }) => `${u.nombresCompletos}`;

  searchUsuario = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.listaUsuarios == null || term.length < 2 || this.cargandoUsuarios ? [] :
        this.listaUsuarios.filter(u => this.containsString(this.usuario.value, u.nombresCompletos)).slice(0, 10))
    )

  selectUsuario(event: any): void {
    this.usuario.setValue(event.item);
    this.usuarioValido = (typeof (this.usuario.value) !== 'string') && (this.usuario.value !== null);
  }

  inputUsuario(): void {    
    this.usuarioValido = false;
  }

  containsString(searchValue: string, ...searchIn: string[]): boolean {
    const concat = searchIn.toString();
    return concat.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
  }

  obtenerAsignacionesPendientes() {
    this.handleSpinner(true);
    this.usuarioService.getAsignacionesPendientes(this.idAprobador, this.codigosAeroplantas)
    .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          this.usuarios = response;
          this.usuariosFiltrados = response;
          this.handleSpinner(false);
          this.filtrarPorMultifiltro();
        }, () => {          
          this.usuarios = [];
          this.usuariosFiltrados = [];
          this.handleSpinner(false);
          this.filtrarPorMultifiltro();
        }
      );
  }

  mapNewClassUser(aeroplanta: Aeroplanta) {
    const newUser = new UsuarioAsignacion();
    newUser.id = this.usuario.value.id;
    newUser.nombresCompletos = this.usuario.value.nombresCompletos;
    newUser.dni = this.usuario.value.dni;
    newUser.codigoAeroplanta = aeroplanta.codigoAeroplanta;
    newUser.rol = this.usuario.value.roles[0] ? this.usuario.value.roles[0] : '';

    return newUser;
  }

  verificarUsuarioAsignado(dni: string, codigoAeroplanta: string, usuarios: Usuario[]): boolean {
    return usuarios.some((usuario: any) =>
      usuario.dni === dni &&
      usuario.aeroplantas.some((aeroplanta: any) => aeroplanta.codigoAeroplanta === codigoAeroplanta)
    );
  }

  addUsuario() {
    this.usuarios = [];
    this.seleccionados = [];
    const aeroplantas = this.usuarioService.aeroplantas.sort((a, b) => { if (a.codigoAeroplanta > b.codigoAeroplanta) { return 1 } else { return -1 } });
    for (let i = 0; i < aeroplantas.length; i++) {
      const usuarioAgregar = this.mapNewClassUser(aeroplantas[i]);   
      this.usuarios.push(usuarioAgregar);
      const existe = this.verificarUsuarioAsignado(usuarioAgregar.dni, usuarioAgregar.codigoAeroplanta, this.listaUsuarios);
      if (existe) {
        usuarioAgregar._bloquear = true;
        this.seleccionados.push(usuarioAgregar);
      }
    }
    this.usuariosFiltrados = this.usuarios;
    this.filtrarPorMultifiltro();
  }

  recargarUsuarios(items: ItemMultiFiltro[]) {
    this.usuariosMultiFiltro = items;
    this.filtrarPorMultifiltro();
  }

  recargarRoles(items: ItemMultiFiltro[]) {
    this.rolesMultiFiltro = items;
    this.filtrarPorMultifiltro();
  }

  recargarDNI(items: ItemMultiFiltro[]) {
    this.dniMultiFiltro = items;
    this.filtrarPorMultifiltro();
  }

  recargarAeroplantas(items: ItemMultiFiltro[]) {
    this.aeroplantasMultiFiltro = items;
    this.filtrarPorMultifiltro();
  }

  extraerSeleccionados() {
    const arrayUsuarioAeroplantas: UsuarioAeroplanta[] = [];
    for (let i = 0; i < this.seleccionados.length; i++) {
      const element = this.seleccionados[i];

      const aeroplanta = this.usuarioService.aeroplantas.find(a => a.codigoAeroplanta === element.codigoAeroplanta);
      if (aeroplanta) {
        const usuarioAeroplanta = new UsuarioAeroplanta();
        usuarioAeroplanta.nombre = aeroplanta.nombre;
        usuarioAeroplanta.id = aeroplanta.id;
        usuarioAeroplanta.codigoAeroplanta = aeroplanta.codigoAeroplanta;
        usuarioAeroplanta.validada = true;
        usuarioAeroplanta.soloPAD = aeroplanta.soloPAD;
        usuarioAeroplanta.habilitarFacturacion = aeroplanta.habilitarFacturacion;
        usuarioAeroplanta.dni = element.dni;

        arrayUsuarioAeroplantas.push(usuarioAeroplanta);
      }
    }
    console.log('usuarios aprobar/rechazar: ', arrayUsuarioAeroplantas);
    return arrayUsuarioAeroplantas ? arrayUsuarioAeroplantas : null;
  }

  aprobar(tipo: ListadoAsignaciones) {
    this.handleSpinner(true);
    if (this.extraerSeleccionados() != null) {
      this.aeroplantasService.putAsignacionAeroplantas(true, this.extraerSeleccionados())
        .subscribe(r => {
          this.seleccionados = [];
          console.log('backend ', r);
          this.messageService.showSuccessMessage(`Se ha realizado correctamente el proceso de aprobado de usuarios ${tipo===ListadoAsignaciones.Pendientes ? 'pendientes' : 'manuales'}.`);
          this.handleSpinner(false);
          this.initPage(tipo);
        }, () => {
          this.messageService.showErrorMessage(`Hubo un error al intentar procesar la aprobacion de usuarios ${tipo===ListadoAsignaciones.Pendientes ? 'pendientes' : 'manuales'}.`);
          this.handleSpinner(false);
        });
    }
  }

  rechazar(tipo: ListadoAsignaciones) {
    this.handleSpinner(true);
    if (this.extraerSeleccionados() != null) {
      this.aeroplantasService.putAsignacionAeroplantas(false, this.extraerSeleccionados())
        .subscribe(r => {
          this.seleccionados = [];
          console.log('backend ', r);
          this.messageService.showSuccessMessage(`Se ha realizado correctamente el proceso de rechazo de usuarios ${tipo===ListadoAsignaciones.Pendientes ? 'pendientes' : 'asignados'}.`)
          this.handleSpinner(false);
          this.initPage(tipo);
        }, () => {
          this.messageService.showErrorMessage(`Hubo un error al intentar procesar el ${tipo===ListadoAsignaciones.Pendientes ? 'rechazo' : 'restringir'} de usuarios ${tipo===ListadoAsignaciones.Pendientes ? 'pendientes' : 'asignados'}.`);
          this.handleSpinner(false);
        });
    }
  }

  get habilitarBotones() {
    const habilitar = this.seleccionados != null && this.seleccionados.filter( s => !s._bloquear ).length > 0;
    return habilitar;
  }

  get busqueda() {
    return this.busquedaFormControl;
  }

  get usuario() {
    return this.usuarioFormControl;
  }

  get messageWarning() {
    switch (this.listadoAsignaciones) {
      case ListadoAsignaciones.Pendientes:
        return 'No hay usuarios pendientes de aprobación.'
      case ListadoAsignaciones.Asignados:
        return 'No hay usuario asignados a mostrar.'
      default:
        return 'Error de información.';
    }
  }

  get idAprobador() {
    return this.usuarioService.getRolesV2() ? this.usuarioService.getRolesV2()[0]?.id : '';
  }

  get codigosAeroplantas() {
    return this.usuarioService.getAeroplantasCurrentUser() ? this.usuarioService.getAeroplantasCurrentUser().map( a => a.codigoAeroplanta ) : [''];
  }
}
